<template>
  <v-main>
    <v-container v-if="!loading">
      <v-toolbar class="elevation-0 mb-3 b-sm-0">
        <div class="pl-0 ml-n4 d-flex align-start align-sm-center flex-column flex-sm-row">
          <span class="headline">Cliente {{ fields.nickname }}</span>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex mr-n4 align-center">
          <v-btn text color="primary" :to="{ name: 'customerForm', params: { id } }">
            <v-icon left>mdi-pencil</v-icon> Editar Cliente
          </v-btn>
        </div>
      </v-toolbar>
      <div class="d-flex justify-start align-start flex-column flex-sm-row">
        <div v-if="fields.image" class="my-3 mr-3">
          <img :src="fields.image" class="preview-image" />
        </div>
        <div class="mr-auto">
          <small>Nome completo</small>
          <br>
          <b>{{ fields.name }}</b>
          <br>
          <small>Telefone</small>
          <br>
          <b>{{ fields.phone | phone_number }}</b>
        </div>
        <div class="mr-auto">
          <small>Documento pessoal</small>
          <br>
          <b>{{ fields.person_document | document }}</b>
          <br>
          <small>Data de nascimento</small>
          <br>
          <b>{{ fields.birthdate | moment('DD/MM/YYYY') }}</b>
        </div>
        <div class="mr-auto">
          <small>E-mail</small>
          <br>
          <b>{{ fields.email }}</b>
          <br>
          <small>Data do cadastro</small>
          <br>
          <b>{{ fields.created_at | moment('DD/MM/YYYY HH:mm:ss') }}</b>
        </div>
        <div class="mr-auto">
          <small>Entrou no App</small>
          <br>
          <b>{{ fields.joined_firebase ? 'Sim' : 'Não' }}</b>
          <br>
          <small>Tipo do login</small>
          <br>
          <b>{{ fields.signup_provider }}</b>
        </div>
      </div>
      <div class="pl-0 d-flex align-start align-sm-center flex-column flex-sm-row">
        <span class="title">Endereço</span>
      </div>
      <div class="d-flex justify-start align-start flex-column flex-sm-row">
        <div class="mr-auto">
          <small>Logradouro</small>
          <br>
          <b>{{ fields.address.street }}</b>
          <br>
          <small>Bairro</small>
          <br>
          <b>{{ fields.address.neighborhood }}</b>
        </div>

        <div class="mr-auto">
          <small>Número</small>
          <br>
          <b>{{ fields.address.number }}</b>
          <br>
          <small>Cidade</small>
          <br>
          <b>{{ fields.address.city }}</b>
        </div>

        <div class="mr-auto">
          <small>Complemento</small>
          <br>
          <b>{{ fields.address.complement }}</b>
          <br>
          <small>Estado</small>
          <br>
          <b>{{ fields.address.state }}</b>
        </div>

        <div class="mr-auto">
          <small>CEP</small>
          <br>
          <b>{{ fields.address.postal_code }}</b>
        </div>
      </div>
      <br>
      <v-tabs
        v-model="tab"
        center-active
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab key="tab-celebrations" href="#tab-celebrations">Turmas</v-tab>
        <!-- <v-tab key="tab-invoices" href="#tab-invoices">Faturas</v-tab> -->
        <v-tab key="tab-notes" href="#tab-notes">Anotações</v-tab>
        <!-- <v-tab key="tab-tickets" href="#tab-tickets">Chamados</v-tab> -->
        <v-tab-item key="tab-item-celebrations" value="tab-celebrations">
          <participants :customer-id="id"></participants>
        </v-tab-item>
        <!-- <v-tab-item key="tab-item-invoices" value="tab-invoices">
          <invoices :customerId="id"></invoices>
        </v-tab-item> -->
        <v-tab-item key="tab-item-notes" value="tab-notes">
          <notes reference="customer" :customerId="id"></notes>
        </v-tab-item>
        <!-- <v-tab-item key="tab-item-tickets" value="tab-tickets">
          <ticket-list reference="customer" :id="id"></ticket-list>
        </v-tab-item> -->
      </v-tabs>
    </v-container>
    <app-loading :visible="loading"></app-loading>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'

import AppLoading from '@/components/Loading'
import Participants from '@/views/Participants/Participants'
// import Invoices from '@/views/Invoices/Invoices'
import Notes from '@/components/NoteList'
// import TicketList from '@/components/TicketTabList'

export default {
  name: 'customerDetails',
  components: {
    AppLoading,
    Participants,
    // Invoices,
    Notes
    // TicketList
  },
  props: ['id'],
  data () {
    return {
      loading: false,
      tab: 'tab-celebrations',
      fields: {
        name: '',
        nickname: '',
        image: '',
        phone: '',
        email: '',
        birthdate: '',
        person_document: '',
        created_at: '',
        signup_provider: [],
        joined_firebase: undefined,
        address: {}
      }
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR'])
  },
  created () {
    if (this.id) {
      this.loading = true

      axios.get('customers/' + this.id)
        .then(response => {
          if (response.data) {
            this.loading = false
            for (let key in this.fields) {
              if (response.data[key]) this.fields[key] = response.data[key]
            }
          } else {
            this.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
            this.$router.push({ name: 'celebrations' })
          }
        })
        .catch(() => {
          this.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          this.$router.push({ name: 'celebrations' })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
